// extracted by mini-css-extract-plugin
export default {"groupNote":"html_groupNote__43oi-","iconEdit":"html_iconEdit__bBn1b"};